/* NOURA diet quiz: questions, scoring and result copy.
   Kept apart from the section so the wording and the weights can be changed
   without touching the markup.

   How scoring works:
   - diet:    points towards one of the four diets. Preferences, not rules.
   - version: points towards Starter, Complete or the bundle.
   - require: a HARD constraint. Someone who does not eat meat must never be
              handed a plan built on meat, however the points fall.
   - flags:   'medical' steers away from the stricter diets and shows a notice,
              'vegan' shows an honest warning that the vegetarian plan is not vegan. */

window.NT_QUIZ = {
  diets: ['Balanced', 'High protein', 'Keto', 'Vegetarian'],
  versions: ['Starter, 7 days', 'Complete, 28 days', 'Everything bundle'],

  questions: [
    {
      id: 'care',
      legend: 'First, one question that changes what we can responsibly recommend.',
      hint: 'Nobody here is a dietitian, so this one matters more than the rest.',
      options: [
        { label: 'None of that applies to me right now' },
        {
          label: 'I am pregnant or breastfeeding, managing a health condition, or already working with a doctor or dietitian',
          flags: ['medical']
        }
      ]
    },
    {
      id: 'animal',
      legend: 'Where do you stand on meat and fish?',
      options: [
        { label: 'I eat everything', diet: { Balanced: 2, 'High protein': 2, Keto: 2 } },
        { label: 'I eat meat, but I would happily eat less of it', diet: { Balanced: 3, Vegetarian: 1 } },
        { label: 'No meat or fish, but eggs and dairy are fine', require: 'Vegetarian' },
        { label: 'Nothing that comes from an animal at all', require: 'Vegetarian', flags: ['vegan'] }
      ]
    },
    {
      id: 'carbs',
      legend: 'How do bread, pasta, rice and potatoes treat you?',
      options: [
        { label: 'Fine. They are the base of most of my meals', diet: { Balanced: 3, Vegetarian: 1 } },
        { label: 'I like them, but I could do with fewer', diet: { Balanced: 1, 'High protein': 2 } },
        { label: 'I genuinely feel better when I barely eat them', diet: { Keto: 6 } }
      ]
    },
    {
      id: 'goal',
      legend: 'What would make a meal a success for you?',
      options: [
        { label: 'It keeps me full for hours, with no raid on the cupboard at four in the afternoon', diet: { 'High protein': 4, Keto: 2 } },
        { label: 'Steady energy, and no heavy slump afterwards', diet: { Balanced: 4 } },
        { label: 'It backs up the training I already do', diet: { 'High protein': 5 } },
        { label: 'It is simply easy, and I stop thinking about food', diet: { Balanced: 3 } }
      ]
    },
    {
      id: 'time',
      legend: 'On a normal weeknight, how long do you actually have?',
      hint: 'This one decides which version we point you at, not which diet.',
      options: [
        { label: 'Fifteen minutes, and that is being generous', version: { 'Starter, 7 days': 1, 'Complete, 28 days': 1 } },
        { label: 'Twenty to thirty minutes is realistic', version: { 'Complete, 28 days': 2 } },
        { label: 'Weeknights are tight, so I would rather cook once at the weekend', version: { 'Complete, 28 days': 2, 'Everything bundle': 2 } }
      ]
    },
    {
      id: 'who',
      legend: 'Who are you cooking for?',
      options: [
        { label: 'Just me', version: { 'Starter, 7 days': 2, 'Complete, 28 days': 1 } },
        { label: 'Me and one other person', version: { 'Complete, 28 days': 2 } },
        { label: 'A whole household', version: { 'Complete, 28 days': 1, 'Everything bundle': 3 } }
      ]
    },
    {
      id: 'history',
      legend: 'Have you followed a written meal plan before?',
      options: [
        { label: 'Never, this would be the first', version: { 'Starter, 7 days': 3 } },
        { label: 'I have started one and drifted off it', version: { 'Complete, 28 days': 3 } },
        { label: 'Yes, and I stick to them. I want the whole thing', version: { 'Everything bundle': 4 } }
      ]
    }
  ],

  why: {
    Balanced: 'Balanced is built around ordinary food in ordinary amounts, close to what the USDA and the NHS actually recommend. It is the one that asks least of you.',
    'High protein': 'High protein puts the protein first in every meal, which is the part that keeps you full between meals instead of reaching for something mid afternoon.',
    Keto: 'Keto keeps starch and sugar low and leans on fat and protein instead. It is the strictest of the four, so it works best when you already know low carb suits you.',
    Vegetarian: 'Vegetarian drops meat and fish and still gets the protein in, using eggs, dairy, beans and lentils rather than a pile of side dishes.'
  },

  notes: {
    medical: 'You told us a doctor or a dietitian is already involved, so the quiz has stayed away from the stricter plans. Talk to them before you change how you eat. This is a meal plan, not medical advice, and nobody here is qualified to give any.',
    vegan: 'You said nothing from an animal at all, so here is the honest answer: the Vegetarian plan uses eggs and dairy and is not vegan as written. The swap pages cover some of it, not all of it. Take the free sample first and decide from that.',
    requiredButMedical: 'We have kept you on the plan that matches what you do not eat, because that is not something a quiz should override. Since a doctor or dietitian is involved, run it past them first.'
  }
};